import { LANG_FR } from "@middleware/constants";
import { ILocal } from "@middleware/types";

export const getLocale = (): ILocal => {
  return LANG_FR;
};
